import React, { useState, useEffect } from 'react';

import classes from './CleaveInput.module.scss';
import Cleave from 'cleave.js/react';
import InputLabel from '../InputLabel/InputLabel';

const CleaveInput = (props) => {
	const [value, setValue] = useState(props.defaultValue || null);

	useEffect(() => {
		setValue(props.defaultValue);
	}, [props.defaultValue]);

	return (
		<div className={props.className} style={{ ...props.style }}>
			<InputLabel
				text={props.label}
				// extraText={props.extraText}
				// error={props.error}
				// required={props.required}
				// color={labelColor}
			/>
			<Cleave
				placeholder={props.placeholder}
				options={props.options}
				value={value}
				onChange={(e) => {
					setValue(e.target.value);
					if (props.onChange) {
						props.onChange(e.target.value);
					}
				}}
				className={classes.input}
				style={{ borderColor: '#CED4DA' }}
				readOnly={props.readOnly}
			/>
		</div>
	);
};

export default CleaveInput;
